import {
    MAILING_ERROR, MAILING_LOADED, MAILING_LOADING,
    MAILING_RESET_MESSAGE,
    MAILING_SUBSCRIBE,
    MAILING_UNSUBSCRIBE
} from '../actions/mailing.actions';

const initialState = {
    error: null,
    isSuccess: false,
    isLoading: false
};

const MailingReducer = function (state = initialState, action) {
    switch (action.type) {
        case MAILING_ERROR:
            return {
                ...state,
                error: action.payload,
                isSuccess: false
            };
        case MAILING_SUBSCRIBE:
            return {
                ...state,
                error: initialState.error,
                isSuccess: true
            };
        case MAILING_UNSUBSCRIBE:
            return {
                ...state,
                error: initialState.error,
                isSuccess: true
            };
        case MAILING_RESET_MESSAGE:
            return {
                ...state,
                error: initialState.error,
                isSuccess: initialState.isSuccess
            };
        case MAILING_LOADING:
            return {
                ...state,
                isLoading: true
            };
        case MAILING_LOADED:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
};

export default MailingReducer;